/**
 * 智能体流式处理相关的全局状态
 * 这些变量在模块级别共享，支持多会话并发
 */

// 会话隔离的思考计时器管理
export const thinkingTimerMap = new Map<string, ReturnType<typeof setInterval>>();
export const thinkingSecondsMap = new Map<string, number>();

// 🔵 #21: pendingLocalMsgIdsSet 已移除，builder 架构下不再需要本地 ID 替换

// 搜索会话状态管理
export interface SearchSessionState {
  version: number;
  phase: string | null;
  latestData: any;
  processedPhases: Set<string>;
  lastAccessTime: number;
}

export const searchSessionMap = new Map<string, SearchSessionState>();

// 待生成的画布节点映射（taskKey → nodeId）
export const pendingNodeMap = new Map<string, string>();
